import React, { useEffect, useState, useRef } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
import "./Dashboard.scss";
import useFullPageLoader from "common/UseFullPageLoader";
import { toastMessage } from "utils/toastMessage";
import {
  dashbaordCompletionRateApi,
  dashboardAnalyticsGraphDataApi,
  dashboardSubscriptionDataApi,
  dashboardUserOutfitHandlerApi,
  getDashboardDetailApi,
} from "services/dasboard";

const Dashboard = () => {
  // State Handler
  const [dashboardDetail, setDashboardDetail] = useState({});
  const [dashboardGraphData, setDashboardGraphData] = useState({});
  const [dashbaordCompletionRateData, setDashboardCompletionRateData] =
    useState({});
  const [dashboardSubscriptionGraphData, setDashboardSubscriptionGraphData] =
    useState([]);

  const [dashboardUserChartData,setDashboardUserChartData] = useState({})
  const [dashboardOutfitCreation,setDashboardOutfitCreation] = useState({})

  const bodyShapeChartRef = useRef(null);
  const styleIdentityChartRef = useRef(null);
  const flauntPartsChartRef = useRef(null);
  const downplayPartsChartRef = useRef(null);
  const completionRateChartRef = useRef(null);
  const subscriptionPurchaseTrend = useRef(null);
  const userChatEngagementRef = useRef(null);
  const userOutfitCreationRef = useRef(null);
  // console.log('dashboardSubscriptionGraphData', dashboardSubscriptionGraphData)
  // hooks handler
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // Function handler

  // Transform graph data handler
  const transformGraphData = ({
    data = [],
    givenLabel = "",
    colorArray = [],
    labelKey = "_id",
    labelValue = "count",
  }) => {
    return {
      labels: data?.length ? data?.map((item) => item[labelKey]) : [],
      datasets: [
        {
          label: givenLabel || "",
          data: data?.length ? data?.map((item) => item[labelValue]) : [],
          backgroundColor: colorArray?.length ? colorArray : [],
        },
      ],
    };
  };

  // const bodyShapeData = {
  //   labels: [
  //     "Round",
  //     "Triangle",
  //     "Hourglass",
  //     "Rectangle",
  //     "Inverted Triangle",
  //   ],
  //   datasets: [
  //     {
  //       data: [30, 25, 20, 15, 10],
  //       backgroundColor: [
  //         "#FFB6B6", // Light Red for Round
  //         "#D4F4DD", // Light Green for Triangle
  //         "#CCE5FF", // Light Blue for Hourglass
  //         "#F9D8E7", // Light Pink for Rectangle
  //         "#E2D4F4",
  //       ],
  //     },
  //   ],
  // };

  // const styleIdentityData = {
  //   labels: ["Bold Boss", "Dreamy Diva", "Timeless Queen", "Effortless Chic"],
  //   datasets: [
  //     {
  //       data: [40, 30, 20, 10],
  //       backgroundColor: [
  //         "#FFE4B2", // Light Orange for Bold Boss
  //         "#E0B3E6", // Light Purple for Dreamy Diva
  //         "#CDEDEA", // Light Teal for Timeless Queen
  //         "#B0D6F1",
  //       ], // Light Blue for Effortless Chic,
  //     },
  //   ],
  // };

  // const flauntPartsData = {
  //   labels: ["Waist", "Legs", "Neckline", "Arms", "Buttocks"],
  //   datasets: [
  //     {
  //       label: "Number of Users",
  //       data: [50, 30, 10, 5, 5],
  //       backgroundColor: [
  //         "#FFE4B2", // Light Orange for Bold Boss
  //         "#E0B3E6", // Light Purple for Dreamy Diva
  //         "#CDEDEA", // Light Teal for Timeless Queen
  //         "#B0D6F1", // Light Blue for Effortless Chic
  //       ],
  //     },
  //   ],
  // };

  // const downplayPartsData = {
  //   labels: ["Waist", "Arms", "Back", "Neckline"],
  //   datasets: [
  //     {
  //       label: "Number of Users",
  //       data: [40, 30, 20, 10],
  //       backgroundColor: [
  //         "#FFC2C7", // Light Pink for Waist
  //         "#B9DFFF", // Light Blue for Legs
  //         "#FFE7B4", // Light Yellow for Neckline
  //         "#C2F2E3", // Light Teal for Arms
  //         "#D4C2FF",
  //       ], // Light Purple for Buttock],
  //     },
  //   ],
  // };

  // const createChart = (ref, type, data) => {
  //   if (ref.current) {
  //     // Destroy the existing chart if it exists
  //     if (ref.current.chartInstance) {
  //       ref.current.chartInstance.destroy();
  //     }
  //     // Create a new chart and attach it to the ref
  //     ref.current.chartInstance = new Chart(ref.current, {
  //       type,
  //       data,
  //       options: {
  //         plugins: {
  //           tooltip: {
  //             callbacks: {
  //               label: (tooltipItem) => {
  //                 const label = tooltipItem.label;
  //                 const value = tooltipItem.raw;
  //                 return `${label}: ${value} users`;
  //               },
  //             },
  //           },
  //         },
  //         scales:
  //           type === "bar"
  //             ? {
  //                 x: { title: { display: true, text: "Parts" } },
  //                 y: {
  //                   title: { display: true, text: "Users" },
  //                   beginAtZero: true,
  //                 },
  //               }
  //             : {},
  //       },
  //     });
  //   }
  // };

  const createChart = (ref, type, data) => {
    if (ref.current) {
      // Destroy the existing chart if it exists
      if (ref.current.chartInstance) {
        ref.current.chartInstance.destroy();
      }

      const total = data.datasets[0].data.reduce(
        (acc, value) => acc + value,
        0
      );

      ref.current.chartInstance = new Chart(ref.current, {
        type,
        data,
        options: {
          plugins: {
            datalabels: {
              formatter: (value) => {
                let percentage = ((value / total) * 100).toFixed(2);
                return `${percentage}%`;
              },
              color: "#fff",
              anchor: "end",
              align: "start",
              font: {
                weight: "bold",
              },
            },
            tooltip: {
              callbacks: {
                label: (tooltipItem) => {
                  const label = tooltipItem.label;
                  const value = tooltipItem.raw;
                  let percentage = ((value / total) * 100).toFixed(2);
                  return `${label}: ${value} users (${percentage}%)`;
                },
              },
            },
          },
          scales:
            type === "bar"
              ? {
                x: { title: { display: true, text: "Parts" } },
                y: {
                  title: { display: true, text: "Users" },
                  beginAtZero: true,
                },
              }
              : {},
        },
        plugins: [ChartDataLabels], // Add ChartDataLabels plugin
      });
    }
  };

  // Fetch Dashboard Detail

  const getDashboardDetail = async () => {
    try {
      showLoader();
      const res = await getDashboardDetailApi();
      if (res?.data?.status === 200) {
        setDashboardDetail(res?.data?.data || "");
      } else {
        setDashboardDetail("");
        toastMessage(res.message, "error");
      }
    } catch (err) {
      toastMessage(err, "error");
    } finally {
      hideLoader();
    }
  };

  // Fetch Dashboard Graph Detail

  const dashboardAnalyticsGraphData = async () => {
    try {
      showLoader();
      const res = await dashboardAnalyticsGraphDataApi();
      if (res?.data?.status === 200) {
        setDashboardGraphData(res?.data?.data || "");
      } else {
        setDashboardGraphData("");
        toastMessage(res.message, "error");
      }
    } catch (err) {
      toastMessage(err, "error");
    } finally {
      hideLoader();
    }
  };

  // Fetch Dashboard Completion Detail

  const dashbaordCompletionRate = async () => {
    try {
      showLoader();
      const res = await dashbaordCompletionRateApi();
      if (res?.data?.status === 200) {
        setDashboardCompletionRateData(res?.data?.data || "");
      } else {
        setDashboardCompletionRateData("");
        toastMessage(res.message, "error");
      }
    } catch (err) {
      toastMessage(err, "error");
    } finally {
      hideLoader();
    }
  };

  // Fetch dashbaord subscription data

  const dashboardSubscriptionDataHandler = async () => {
    try {
      showLoader();
      const res = await dashboardSubscriptionDataApi();
      if (res?.data?.status === 200) {
        if (res?.data?.data) {
          const resultArray = Object.entries(res?.data?.data)?.map(
            ([key, value]) => ({ _id: key, count: value })
          );
          setDashboardSubscriptionGraphData(resultArray || []);
        }
      } else {
        setDashboardSubscriptionGraphData("");
        toastMessage(res.message, "error");
      }
    } catch (err) {
      toastMessage(err, "error");
    } finally {
      hideLoader();
    }
  };

  const dashboardUserOutfitHandler = async () => {
    try {
      showLoader();
      const res = await dashboardUserOutfitHandlerApi();
      // console.log(res,"res")
      if (res?.data?.status === 200) {
        const chartData = res?.data?.data?.chartData || [];
        // const {}
        // setDashboardUserChartData(res?.data?.data.chartData || {})
        // setDashboardOutfitCreation()
        const dashboardChartApiData= ["Total Users","Users Who Initiated Chats"]
        const dashboardOutfitApiData = ["Total Users","Users Who Created Outfits"]
        setDashboardUserChartData(chartData.filter(item => dashboardChartApiData.includes(item.label)));
        setDashboardOutfitCreation(chartData.filter(item => dashboardOutfitApiData.includes(item.label)));
      } else {
        setDashboardUserChartData("");
        toastMessage(res.message, "error");
      }
    } catch (err) {
      toastMessage(err, "error");
    } finally {
      hideLoader();
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        getDashboardDetail(),
        dashboardAnalyticsGraphData(),
        dashbaordCompletionRate(),
        dashboardSubscriptionDataHandler(),
        dashboardUserOutfitHandler()
      ]);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (dashboardAnalyticsGraphData) {
      createChart(
        bodyShapeChartRef,
        "pie",
        transformGraphData({
          data: dashboardGraphData?.bodyShape || [],
          givenLabel: "",
          colorArray: [
            "#FFB6B6", // Light Red for Round
            "#D4F4DD", // Light Green for Triangle
            "#CCE5FF", // Light Blue for Hourglass
            "#F9D8E7", // Light Pink for Rectangle
            "#E2D4F4",
          ],
        })
      );
      createChart(
        styleIdentityChartRef,
        "pie",
        transformGraphData({
          data: dashboardGraphData?.styleIdentity || [],
          givenLabel: "",
          colorArray: [
            "#FFE4B2", // Light Orange for Bold Boss
            "#E0B3E6", // Light Purple for Dreamy Diva
            "#CDEDEA", // Light Teal for Timeless Queen
            "#B0D6F1",
          ],
        })
      );
      createChart(
        flauntPartsChartRef,
        "bar",
        transformGraphData({
          data: dashboardGraphData?.flauntParts || [],
          givenLabel: "Number of Users",
          colorArray: [
            "#FFE4B2", // Light Orange for Bold Boss
            "#E0B3E6", // Light Purple for Dreamy Diva
            "#CDEDEA", // Light Teal for Timeless Queen
            "#B0D6F1", // Light Blue for Effortless Chic
          ],
        })
      );
      createChart(
        downplayPartsChartRef,
        "bar",
        transformGraphData({
          data: dashboardGraphData?.downplayParts || [],
          givenLabel: "Number of Users",
          colorArray: [
            "#FFC2C7", // Light Pink for Waist
            "#B9DFFF", // Light Blue for Legs
            "#FFE7B4", // Light Yellow for Neckline
            "#C2F2E3", // Light Teal for Arms
            "#D4C2FF",
          ],
        })
      );

    }
  }, [dashboardGraphData]);

  useEffect(() => {
    if (dashbaordCompletionRateData) {
      createChart(
        completionRateChartRef,
        "pie",
        transformGraphData({
          data: dashbaordCompletionRateData?.palettes || [],
          givenLabel: "",
          colorArray: [
            "#FFB6B6", // Light Red for Round
            "#D4F4DD", // Light Green for Triangle
            "#CCE5FF", // Light Blue for Hourglass
            "#F9D8E7", // Light Pink for Rectangle
            "#E2D4F4",
          ],
          labelKey: "paletteName",
          labelValue: "count",
        })
      );
    }
  }, [dashbaordCompletionRateData]);

  // Helper function to format labels
  const formatLabel = (label) => {
    if (label === "notPurchased") {
      return "Not Purchased";
    }
    return label.charAt(0).toUpperCase() + label.slice(1);
  };
  // useEffect(() => {
  //   if (dashboardSubscriptionGraphData) {
  //     createChart(
  //       subscriptionPurchaseTrend,
  //       "pie",
  //       transformGraphData({
  //         data: dashboardSubscriptionGraphData || [],
  //         givenLabel: "",
  //         colorArray: [
  //           "#FFB6B6", // Light Red for Round
  //           "#D4F4DD", // Light Green for Triangle
  //           "#CCE5FF", // Light Blue for Hourglass
  //           "#F9D8E7", // Light Pink for Rectangle
  //           "#E2D4F4",
  //         ],
  //       })
  //     );
  //   }
  // }, [dashboardSubscriptionGraphData]);
  useEffect(() => {
    if (dashboardSubscriptionGraphData) {
      const formattedData = dashboardSubscriptionGraphData?.map(item => ({
        ...item,
        _id: formatLabel(item._id),
      }));

      createChart(
        subscriptionPurchaseTrend,
        "pie",
        transformGraphData({
          data: formattedData,
          givenLabel: "",
          colorArray: [
            "#FFB6B6", // Light Red for Round
            "#D4F4DD", // Light Green for Triangle
            "#CCE5FF", // Light Blue for Hourglass
            "#F9D8E7", // Light Pink for Rectangle
            "#E2D4F4",
          ],
      
        })
      );
    }
}, [dashboardSubscriptionGraphData]);

useEffect(()=>{
if(dashboardUserChartData){
  createChart(
    userChatEngagementRef,
    "pie",
    transformGraphData({
      data: dashboardUserChartData || [],
      givenLabel: "",
      colorArray: [
        "#FFE4B2", // Light Orange for Bold Boss
        "#E0B3E6", // Light Purple for Dreamy Diva
        "#CDEDEA", // Light Teal for Timeless Queen
        "#B0D6F1",
      ],
          labelKey:"label",
          labelValue:"value"
    })
  );
  createChart(
    userOutfitCreationRef,
    "pie",
    transformGraphData({
      data: dashboardOutfitCreation || [],
      givenLabel: "",
      colorArray: [
        "#FFE4B2", // Light Orange for Bold Boss
        "#E0B3E6", // Light Purple for Dreamy Diva
        "#CDEDEA", // Light Teal for Timeless Queen
        "#B0D6F1",
      ],
          labelKey:"label",
          labelValue:"value"
    })
  );
}
},[dashboardUserChartData])


  return (
    <>
      {loader}
      <div className="dashboard_home">
        <div className="dashboard_title">
          <h3>Dashboard</h3>
        </div>
        <div className="container mt-4">
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="custom-card">
                <h4>Total Users</h4>
                <p>{(dashboardDetail && dashboardDetail?.totalUsers) || 0}</p>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="custom-card">
                <h4>Active Users</h4>
                <p>{(dashboardDetail && dashboardDetail?.activeUsers) || 0}</p>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="custom-card">
                <h4>In- active Users</h4>
                <p>
                  {(dashboardDetail && dashboardDetail?.inActiveUsers) || 0}
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="custom-card">
                <h4>Total Events</h4>
                <p>{(dashboardDetail && dashboardDetail?.totalEvents) || 0}</p>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="custom-card">
                <h4>Total Posts</h4>
                <p>{(dashboardDetail && dashboardDetail?.totalPosts) || 0}</p>
              </div>
            </div>
          </div>
          <div className="chart_wrap">
            <div className="chart-box">
              <h2>Body Shape Distribution</h2>
              <div className="canvas_wrap">
                <canvas ref={bodyShapeChartRef} id="bodyShapeChart"></canvas>
              </div>
            </div>
            <div className="chart-box">
              <h2>Style Identity Distribution</h2>
              <div className="canvas_wrap">
                <canvas
                  ref={styleIdentityChartRef}
                  id="styleIdentityChart"
                ></canvas>
              </div>
            </div>
          </div>
          <div className="chart_wrap">
            <div className="chart-box">
              <h2>Color Completion Rate</h2>
              <div className="canvas_wrap">
                <canvas
                  ref={completionRateChartRef}
                  id="completionRateChartRef"
                ></canvas>
              </div>
            </div>
            <div className="chart-box">
              <h2>Premium Subscription Purchases Trend</h2>
              <div className="canvas_wrap">
                <canvas
                  ref={subscriptionPurchaseTrend}
                  id="subscriptionPurchaseTrend"
                ></canvas>
              </div>
            </div>
          </div>

            <div className="chart_wrap">
            <div className="chart-box">
              <h2>User Chat Engagement</h2>
              <div className="canvas_wrap">
                <canvas
                  ref={userChatEngagementRef}
                  id="userChatEngagementRef"
                ></canvas>
              </div>
            </div>
            <div className="chart-box">
              <h2>User Outfit Creations</h2>
              <div className="canvas_wrap">
                <canvas
                  ref={userOutfitCreationRef}
                  id="userOutfitCreationRef"
                ></canvas>
              </div>
            </div>
          </div>

          
          <div className="chart_wrap">
            <div className="chart-box">
              <h2>Flaunt Parts</h2>
              <canvas ref={flauntPartsChartRef} id="flauntPartsChart"></canvas>
            </div>
            <div className="chart-box">
              <h2>Downplay Parts</h2>
              <canvas
                ref={downplayPartsChartRef}
                id="downplayPartsChart"
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
